import { FC, useState } from "react";
import { ErrorMessage, Input } from "@/components/UI";
import { ButtonIcon } from "@/components/UI/Buttons";
import { isPasswordValid } from "@/utils/formValidator";

interface PasswordFormProps {
  onSubmit: (password: string) => Promise<void>;
  isLoading?: boolean;
  submitButtonLabel?: string;
  showLabels?: boolean;
}

const PasswordForm: FC<PasswordFormProps> = ({
  onSubmit,
  isLoading = false,
  submitButtonLabel = "Patvirtinti",
  showLabels = true,
}) => {
  const [password, setPassword] = useState<string>("");
  const [passwordConfirm, setPasswordConfirm] = useState<string>("");
  const [error, setError] = useState<string | undefined>();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setError(undefined);

    if (!password || !passwordConfirm) {
      setError("Prašome užpildyti visus laukus");
      return;
    }

    if (!isPasswordValid(password)) {
      setError(
        "Slaptažodis neatitinka saugumo reikalavimų. Slaptažodis turi turėti bent 1 didžiąją, 1 mažają raidę ir skaičių. Min. 8 simboliai.",
      );
      return;
    }

    if (password !== passwordConfirm) {
      setError("Slaptažodžiai nesutampa");
      return;
    }

    try {
      await onSubmit(password);
    } catch (err: any) {
      setError(err.message || "Klaida");
    }
  };

  return (
    <form
      className="flex w-full flex-col justify-center gap-[40px]"
      onSubmit={handleSubmit}
    >
      <div className="flex w-full flex-col justify-center gap-[18px]">
        <Input
          label={showLabels ? "Naujas slaptažodis" : "Slaptažodis"}
          type="password"
          value={password}
          required
          minLength={8}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Input
          label={
            showLabels
              ? "Pakartokite naują slaptažodį"
              : "Pakartokite slaptažodį"
          }
          type="password"
          value={passwordConfirm}
          required
          minLength={8}
          onChange={(e) => setPasswordConfirm(e.target.value)}
        />
      </div>

      {error && <ErrorMessage error={error} />}

      <div className="mx-auto mb-10 md:mb-14 invert">
        <ButtonIcon
          label={submitButtonLabel}
          icon="arrow-right"
          theme="light"
          disabled={isLoading}
          submitType={true}
          className="w-min"
        />
      </div>
    </form>
  );
};

export default PasswordForm;
